import { useRef } from "react";
import { Link } from "react-router-dom";
import { motion, useScroll, useTransform } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { Eyebrow, Reveal } from "./Motion";

export const AboutTeaser = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);

  return (
    <section ref={ref} data-testid="about-teaser-section" className="relative overflow-hidden px-5 py-24 sm:px-8 sm:py-32 lg:px-12">
      <div className="mx-auto grid max-w-[1400px] items-center gap-14 lg:grid-cols-12">
        <Reveal className="relative lg:col-span-5">
          <div className="absolute -inset-10 rounded-full bg-[radial-gradient(closest-side,rgba(212,175,55,0.16),transparent)]" />
          <div className="clip-arch relative aspect-[4/5] overflow-hidden border border-[#D4AF37]/30">
            <motion.img style={{ y }} src="/team/astrologer.webp" alt="Our astrologer and spiritual healer in Calgary" loading="lazy" className="absolute inset-0 h-[116%] w-full object-cover object-top" />
            <div className="absolute inset-0 bg-gradient-to-t from-[#07040D]/40 via-transparent to-transparent" />
          </div>
          <p className="font-cinzel absolute -bottom-4 left-6 bg-[#07040D] px-4 py-2 text-[11px] tracking-[0.3em] text-[#D4AF37]">EST. IN CALGARY</p>
        </Reveal>
        <div className="lg:col-span-6 lg:col-start-7">
          <Reveal>
            <Eyebrow>About the Astrologer</Eyebrow>
            <h2 className="font-display mt-5 text-4xl leading-[1.02] text-white sm:text-5xl lg:text-6xl">
              Ancient wisdom, offered with <span className="italic gold-text">modern care</span>
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-8 text-base leading-relaxed text-slate-300 sm:text-lg">
              Our practice brings together Vedic astrology, intuitive reading and traditional spiritual healing. Each consultation
              begins by listening — to your questions, your circumstances and what you hope to understand.
            </p>
            <p className="mt-5 text-base leading-relaxed text-slate-300">
              From relationships and marriage to career moves and family matters, we offer honest, compassionate guidance
              designed to help you make decisions with a clearer mind and a calmer heart.
            </p>
            <Link to="/about" data-testid="about-read-more-link" className="mt-10 inline-flex items-center gap-2 border-b border-[#D4AF37]/40 pb-1 text-sm text-[#F3E5AB] transition-[gap,border-color] duration-300 hover:gap-3 hover:border-[#D4AF37]">
              Read our story <ArrowUpRight className="h-4 w-4" />
            </Link>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
